import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0
}: AnimatedSectionProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-12">
      {children}
    </motion.section>;
}